export const authorizationKeys = {
  all: ["authorization"] as const,
  myPermissions: ["authorization", "me", "permissions"] as const,
  roles: ["authorization", "roles"] as const,
  role: (id: number) => ["authorization", "roles", id] as const,
  permissions: (module?: string) =>
    ["authorization", "permissions", module ?? "all"] as const,
};
